export default __webpack_public_path__ + "assets/img/ic-chat.81ca121e1647174484df0af04a4c402d.svg";